import TYPES from './_actionTypes';

// payload: { file, collegeId, batch, semester }
export const uploadStudentsRequest = (params) => ({
  type: TYPES.UPLOAD_REQUEST,
  payload: params,
});

export const uploadStudentsSuccess = (job) => ({
  type: TYPES.UPLOAD_SUCCESS,
  payload: job,
});

export const uploadStudentsFailure = (error) => ({
  type: TYPES.UPLOAD_FAILURE,
  payload: { error },
});

export const fetchJobStatusRequest = (jobId) => ({
  type: TYPES.FETCH_JOB_STATUS_REQUEST,
  payload: { jobId },
});

export const fetchJobStatusSuccess = (job) => ({
  type: TYPES.FETCH_JOB_STATUS_SUCCESS,
  payload: job,
});

export const fetchJobStatusFailure = (error, status = null) => ({
  type: TYPES.FETCH_JOB_STATUS_FAILURE,
  payload: { error, status },
});

export const clearCurrentJob = () => ({
  type: TYPES.CLEAR_CURRENT_JOB,
});
